/**
 * CargaMedlogCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaMedlog} from '@/model/resource/CargaMedlog'

/* TODO: review generated class */
@HttpExclude()
export class CargaMedlogCollection extends PageCollection<CargaMedlog> {
  constructor() {
    super(CargaMedlog)
  }

  queryAsPage() {
    return this.listCargaMedlog()
  }

  async listCargaMedlog() {
    return await Request.get(`/admin/carga-medlog`, {params: this.params})
      .name('listCargaMedlog')
      .as(this)
      .getResponse()
  }

  async listCsvCargaMedlog() {
    return await Request.get(`/admin/carga-medlog/csv`, {params: this.params})
      .name('listCsvCargaMedlog')
      .as(this)
      .getResponse()
  }
}
